import { useEffect, useState } from "react";
import AnimatedLetters from "../AnimatedLetters/AnimatedLetters";
import { Outlet } from "react-router-dom";
import "./About.scss";

function About() {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3300);
  }, []);

  return (
    <div className="container about-page">
      <div className="page">
        <span className="tags top-html">&lt;/html&gt;</span>
        <span className="tags top-tags">&lt;body&gt;</span>

        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={[
                "A",
                "b",
                "o",
                "u",
                "t",
                " ",
                "M",
                "e",
              ]}
              idx={15}
            />
          </h1>
          <div className="intro-columns">
            <div className="col left-intro">
              <p>
                Hello,
                <br />
                My name is Anuj Rathore, and I am a pre-final year Computer
                Science undergraduate at IIIT Sri City (CGPA: 8.50/10.00).
                <br />
                <br />
                I am passionate about problem solving, backend systems, and
                full-stack development, with strong expertise in NodeJS, ExpressJS,
                ReactJS, distributed databases, caching, and scalable application architectures.
                <br />
                <br />
                I have worked as a Software Engineering Intern at GoBasera and
                an SDE Intern at Quantic Cloud Technologies, where I designed backend
                microservices, engineered fault-tolerant Stripe payment workflows,
                developed 15+ REST APIs, and optimized query latency with Redis caching.
                <br />
                <br />
                I have built full-stack platforms including Medipulse, a real-time
                hybrid healthcare platform with WebRTC &amp; Gemini AI triage, GoHire,
                a multi-database hiring marketplace, and DispatchX, a distributed
                fault-tolerant email delivery platform using RabbitMQ microservices.
                <br />
                <br />
                Alongside development, I am deeply passionate about competitive
                programming. I have solved 1400+ DSA problems and hold the
                titles of Knight on LeetCode (max 1909), 3-Star on CodeChef (max 1604),
                and Pupil on Codeforces (max 1303).
                <br />
                <br />
                Thank you.
              </p>
            </div>

            <div className="col right-highlights">
              <div className="highlight-card">
                <p className="highlight-count">1400+</p>
                <p className="highlight-label">DSA Problems</p>
              </div>

              <div className="platform-grid">
                <div className="platform-card">
                  <div className="platform-info">
                    <p className="platform-rating">1909+ Rating</p>
                    <p className="platform-rank">Knight</p>
                  </div>
                  <a
                    className="platform-link"
                    href="https://leetcode.com/u/Rathore_Anuj_007/"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Open LeetCode profile"
                  >
                    <span className="platform-badge">LeetCode</span>
                  </a>
                </div>

                <div className="platform-card">
                  <div className="platform-info">
                    <p className="platform-rating">1303+ Rating</p>
                    <p className="platform-rank">Pupil</p>
                  </div>
                  <a
                    className="platform-link"
                    href="https://codeforces.com/profile/rathoreanuj01_"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Open Codeforces profile"
                  >
                    <span className="platform-badge">Codeforces</span>
                  </a>
                </div>

                <div className="platform-card">
                  <div className="platform-info">
                    <p className="platform-rating">1604+ Rating</p>
                    <p className="platform-rank">3 Star</p>
                  </div>
                  <a
                    className="platform-link"
                    href="https://www.codechef.com/users/anujrathore36"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Open CodeChef profile"
                  >
                    <span className="platform-badge">CodeChef</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Outlet />
        <span className="tags bottom-tags">
          &lt;/body&gt;
          <br />
          <span className="bottom-tag-html">&lt;/html&gt;</span>
        </span>
      </div>
    </div>
  );
}

export default About;